import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {ListLazy, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledItem = styled.div`
  border-bottom: 1px solid ${({theme}) => theme.gray_1};
  padding: ${convertUnit(8)} ${convertUnit(20)};
`
const StyledDesc = styled(Paragraph)`
  border-bottom: 1px solid ${({theme}) => theme.gray_1};
  border-top: 1px solid ${({theme}) => theme.gray_1};
  padding: ${convertUnit(8)} ${convertUnit(16)};
  text-align: center;
`
export default function GiftShopUploadPublishReportDuplicate({
  data,
}: {
  data: {
    id: string
    status: any
    name: string
  }[]
}) {
  const {translate} = useTranslation()
  const handleRenderItem = useCallback(
    ({name}) => (
      <StyledItem>
        <Paragraph fontSize="m" fontWeight="bold" color="warning_4">
          {name}
        </Paragraph>
      </StyledItem>
    ),
    [],
  )

  return (
    <ListLazy
      data={data}
      keyExtractor={(item) => item.id}
      renderItem={handleRenderItem}
      loadData={() => null}
      listHeaderElement={
        <StyledDesc color="gray_5">
          {translate('giftShop:uploadPublishRetryHeaderDescDuplicate')}
        </StyledDesc>
      }
    />
  )
}
